import React, { useCallback } from 'react'
import classNames from 'classnames'

import Icon from '../../Icon'

import styles from './Checkbox.module.css'

export default function Checkbox({ input, small, ...props }) {
  const { value, onChange } = input || props

  const handleClick = useCallback(
    e => {
      e.stopPropagation()
      e.preventDefault()

      onChange(!value)
    },
    [value, onChange]
  )

  return (
    <div className={styles.wrapper}>
      <div
        className={classNames(
          styles.checkbox,
          value === true && styles.checked,
          small && styles.small
        )}
        onClick={handleClick}
      >
        {value &&
          (value === true ? (
            <Icon
              icon={small ? 'checkmark-naked-small' : 'checkmark-naked'}
              color="white"
            />
          ) : (
            <div className={styles.dash} />
          ))}
      </div>
    </div>
  )
}
